import React, {useRef, useState} from "react"
import {Controller, useForm} from "react-hook-form";
import {maxLength, PasswordValidation, Required} from "../../../../utils/patterns";
import PasswordInput from "../../../../components/common/password-field/PasswordInput";
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import {Col, Form, Row} from "react-bootstrap";
import {useNavigate} from "react-router";
import {notification} from "antd";
import {RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import {UserAuthService} from "../../../../services/user-auth-api.service";

export default function ChangePaswwordSetting() {
    const[loader,setLoader] = useState(false)
    const navigator = useNavigate()
    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors},
        control,
        clearErrors,
        watch
    } = useForm({
        mode: 'onChange',
    })
    const password = useRef({})
    password.current = watch('new_password', '')

    const onSubmit = async (data) => {
        setLoader(true)
        const result = await UserAuthService.ChangePasswordApi(data.old_password, data.new_password, data.cpassword)

        if (result?.data?.data?.status) {
            notification.success({
                message: "Success",
                description: `${result?.data?.data?.message}`,
                placement: "topRight",
                icon: <RoundedCheck/>,
                duration: 2,
            });
            navigator('/')

        }
        setLoader(false)
    }
    return(
        <div className={'change-password'}>
            <h6 className={'setting-heading'}>Change Password</h6>
            <p>Your new password must be different
                from previous used passwords.</p>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={'dfields'}>
                    <Controller
                        name="old_password"
                        defaultValue={''}
                        control={control}
                        rules={{required: Required, pattern:PasswordValidation, maxLength: maxLength(100)}}
                        render={({field: {name, ...field}}) => (
                            <PasswordInput
                                placeholder={'Enter a current password'}
                                label={'Current Password'}
                                field={field}
                                errors={errors.old_password}
                                className={'required'}
                            />
                        )}
                    />
                </div>
                <div className={'dfields'}>
                    <Controller
                        name="new_password"
                        defaultValue={''}
                        control={control}
                        rules={{required: Required, pattern:PasswordValidation, maxLength: maxLength(100)}}
                        render={({field: {name, ...field}}) => (
                            <PasswordInput
                                placeholder={'Enter a new password'}
                                label={'New Password'}
                                field={field}
                                errors={errors.new_password}
                                className={'required'}
                            />
                        )}
                    />
                </div>
                <div className={'dfields'}>
                    <Controller
                        name="cpassword"
                        defaultValue={''}
                        control={control}
                        rules={{
                            required: Required,
                            validate: (value) => value == password.current || 'The password does not match',
                        }}
                        render={({field: {name, ...field}}) => (
                            <PasswordInput
                                placeholder={'Re-enter your new password'}
                                label={'Confirm New Password '}
                                field={field}
                                errors={errors.cpassword}
                                className={'required'}
                            />
                        )}
                    />
                </div>
                <Row>
                    <Col md={12}>
                        <div className={'dfields mt-4'}>
                            <ThemeButton
                                text={'Update'}
                                className={'btn-light-lg'}
                                type={'submit'}
                                loader={loader}
                            />
                        </div>
                    </Col>

                </Row>

            </Form>
        </div>
    )
}